import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Users extends EntityDto implements IEntityDto {
    Emp_Ref_Id	:string 
    User_Id: string;
    UserName:string;
    PrivateComments_Id:string  
    IsDelete:boolean;
    IsActive: boolean;
    // CreatedBy_Id:
    // CreatedOn
    Users :Array<Users>;
    
    constructor() {
        super();
        this.Emp_Ref_Id="00000000-0000-0000-0000-000000000000";
        this.User_Id = "00000000-0000-0000-0000-000000000000";
        this.UserName="";
        this.PrivateComments_Id="00000000-0000-0000-0000-000000000000"
        this.IsActive=true;
        this.IsDelete=false
        this.Users=[];

        this.EntityMetaData = [
          
        ];
    }
}
